module.exports = __webpack_public_path__ + "b12d4e996d1fc33a02b349f084dd7039.MP3";